/*
<summary>
   This enum defines the tool_master.loan_record values (whether a tool is currently on loan).
   Developer: Aashish Singh, Created Date: 25-Aug-2026
</summary>
*/
enum LoanRecordEnum {
  No = 0,
  Yes = 1,
}

export default LoanRecordEnum;
